






























import {
  SelectedTrainer,
  TrainerResponseDTO
} from '@/store/modules/jtms/trainer/trainer.types';
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

@Component({})
export default class SelectTrainerListRow extends Vue {
  @Prop(Object) trainer!: TrainerResponseDTO;

  // Prop to receive the full array of selected trainers from the parent (TrainerDropdown)
  @Prop({ type: Array, required: true })
  readonly selectedTrainers!: TrainerResponseDTO[];

  // Local state for this row's checkbox
  public isSelected: boolean = false;

  getFullName(firstName?: string, lastName?: string) {
    return `${firstName} ${lastName}`;
  }

  getAccreditation(courseType?: string) {
    if (courseType) {
      return `Accreditation: ${courseType}`;
    }
    return `Accreditation: None`;
  }

  // Watcher to update trainer selection in parent component
  @Watch('isSelected')
  onIsSelectedChange(newValue: boolean): void {
    const selectedTrainer: SelectedTrainer = {
      trainer: this.trainer,
      selected: newValue
    };

    this.emitSelectedTrainerToParentComponent(selectedTrainer);
  }

  // Watcher to handle assigning row items when master list from the parent changes
  @Watch('selectedTrainers', { immediate: true })
  onSelectedTrainersChange(): void {
    this.isSelected = this.selectedTrainers.some(
      (t) => t.id === this.trainer.id
    );
  }

  @Emit('selection-change')
  emitSelectedTrainerToParentComponent(newValue: SelectedTrainer) {
    return newValue;
  }
}
